import React from 'react';
import PropTypes from "prop-types";

const PricingButton = ({ title }) => {
  return (
    <a
      rel='noreferrer'
      target='_blank'
      href='https://cookie-script.com/pricing'
      className='btn btn-success ms-2'
    >
      <i className="fas fa-tag fs-4 me-2"/>
      {title}
    </a>
  )
}

PricingButton.propTypes  = {
  title: PropTypes.string.isRequired,
}

export default PricingButton